module.exports = __webpack_public_path__ + "assets/d0e26f117ba32996ec56777645cd7600.png";